import React, { useState, useEffect } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	MenuItem,
	Stack,
	Typography
} from "@mui/material";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { listFlows, sendFlowByTicket } from "../../services/wabaFeatures";

// Envia um formulário (WhatsApp Flow) publicado para o contato do ticket.
// A tela inicial do flow é resolvida no backend automaticamente.
const WabaFlowModal = ({ open, onClose, whatsappId, to, ticketId }) => {
	const [flows, setFlows] = useState([]);
	const [flowId, setFlowId] = useState("");
	const [bodyText, setBodyText] = useState("");
	const [flowCta, setFlowCta] = useState("Preencher");
	const [loading, setLoading] = useState(false);
	const [sending, setSending] = useState(false);

	useEffect(() => {
		if (!open || !whatsappId) return;
		const load = async () => {
			setLoading(true);
			try {
				const { data } = await listFlows(whatsappId);
				const pub = (data?.data || []).filter(f => f.status === "PUBLISHED");
				setFlows(pub);
				if (pub[0]) setFlowId(pub[0].id);
			} catch (err) {
				toastError(err);
			} finally {
				setLoading(false);
			}
		};
		load();
	}, [open, whatsappId]);

	const handleSend = async () => {
		if (!flowId || !bodyText) {
			toast.error("Escolha um formulário e escreva a mensagem.");
			return;
		}
		setSending(true);
		try {
			await sendFlowByTicket(whatsappId, { to, ticketId, flowId, flowCta: flowCta || "Preencher", bodyText });
			toast.success("Formulário enviado!");
			setBodyText("");
			onClose();
		} catch (err) {
			toastError(err);
		} finally {
			setSending(false);
		}
	};

	return (
		<Dialog open={open} onClose={sending ? undefined : onClose} maxWidth="sm" fullWidth>
			<DialogTitle>Enviar formulário (WhatsApp Flow)</DialogTitle>
			<DialogContent>
				{loading ? (
					<Typography sx={{ py: 2 }}>Carregando formulários…</Typography>
				) : flows.length === 0 ? (
					<Typography sx={{ py: 2 }}>
						Nenhum formulário publicado nesta conta. Crie um no Gerenciador da Meta (ou peça ao suporte).
					</Typography>
				) : (
					<Stack spacing={2} sx={{ mt: 1 }}>
						<TextField
							select
							label="Formulário"
							value={flowId}
							onChange={e => setFlowId(e.target.value)}
							fullWidth
						>
							{flows.map(f => (
								<MenuItem key={f.id} value={f.id}>
									{f.name}
								</MenuItem>
							))}
						</TextField>
						<TextField
							label="Mensagem"
							value={bodyText}
							onChange={e => setBodyText(e.target.value)}
							required
							multiline
							minRows={2}
							fullWidth
						/>
						<TextField
							label="Texto do botão"
							value={flowCta}
							onChange={e => setFlowCta(e.target.value)}
							inputProps={{ maxLength: 30 }}
							fullWidth
						/>
					</Stack>
				)}
			</DialogContent>
			<DialogActions sx={{ p: 2, gap: 1 }}>
				<Button onClick={onClose} disabled={sending}>
					Cancelar
				</Button>
				<Button
					onClick={handleSend}
					variant="contained"
					disabled={sending || loading || !flows.length}
				>
					{sending ? "Enviando..." : "Enviar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default WabaFlowModal;
